import {
    FETCH_P24_TRANSACTION_LOGS
} from "./actionTypes";
import axios from "axios";
import { P24_TRANSACTION_LOGS_URL } from "../../config"

/**
 * Pobieranie listy logów p24 dla podanej transakcji z serwera
 *
 * @param {int} transactionId identyfikator transakcji 
 */
export const fetchP24TransactionLogs = (transactionId) => {
    return dispatch => {
        return axios
            .get(P24_TRANSACTION_LOGS_URL(transactionId))
            .then(response => {
                dispatch(fetchP24TransactionLogsSuccess(response.data));
            })
    }
}

/**
 * Akcja pomyślnego pobrania listy logów p24 dla transakcji
 * 
 * @param {object} data Obiekt pobranej listy logów
 */
const fetchP24TransactionLogsSuccess = data => {
    return {
        type: FETCH_P24_TRANSACTION_LOGS,
        payload: data
    };
};